export const HBL_TYPES_ALL = [
  'original',
  'express',
  'seaWaybill',
  'seawaybill',
  'seawayBill',
  'draft',
  'telexRelease',
  'nonNegotiableCopy',
  '',
] as const

export const HBL_TYPES = ['original', 'express', 'seaWaybill', 'draft', 'telexRelease', 'nonNegotiableCopy'] as const

type NarrowString = string & { __brand: 'HBLType' }

export type HblTypeAll = (typeof HBL_TYPES_ALL)[number] | NarrowString

export type HblType = Exclude<HblTypeAll, 'seawaybill' | 'seawayBill' | ''> | undefined

export const toHBLType = (type?: string): HblType => {
  if (type === 'seawaybill' || type === 'seawayBill') {
    return 'seaWaybill'
  }

  if (type === '') {
    return undefined
  }

  if (isKnownHBLType(type)) {
    return type
  }

  return type as HblType
}

export const isKnownHBLType = (type: unknown): type is Exclude<HblType, NarrowString | undefined> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return HBL_TYPES.includes(type as any)
}
